module.exports = __webpack_public_path__ + "img/cr.5e2710a6.svg";